/**
 * Builds the public URL path for an event.
 * Format: /:producerSlug/:eventNameSlug/:sequentialId
 */
export function slugify(text: string): string {
  return text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-|-$/g, "")
    .slice(0, 80);
}

export function buildEventPath(producerSlug: string, eventName: string, sequentialId: number): string {
  const eventSlug = slugify(eventName);
  return `/${producerSlug}/${eventSlug}/${sequentialId}`;
}

export function buildEventUrl(producerSlug: string, eventName: string, sequentialId: number): string {
  return `${window.location.origin}${buildEventPath(producerSlug, eventName, sequentialId)}`;
}
